var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEngagement = function SvgEngagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 24 24"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "engagement_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#engagement_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.394 19.492a6.836 6.836 0 1 0-6.836-6.836 6.835 6.835 0 0 0 6.836 6.836m0 1.303a8.14 8.14 0 1 0 0-16.278 8.14 8.14 0 0 0 0 16.278"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M19.83.093a.328.328 0 0 1 .553.192l.235 1.888.51-.499a.497.497 0 0 1 .696.005l.737.737c.19.19.189.498-.004.686l-.481.47 1.639.203c.266.033.38.36.192.554l-4.155 4.295a.32.32 0 0 1-.232.098h-2.725l-3.79 3.698q.016.116.016.236a1.628 1.628 0 1 1-1.488-1.622l3.903-3.806v-2.75c0-.086.035-.17.098-.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.76 10.469-.992.991a3.58 3.58 0 0 1-3.375 4.776l-.001.001a3.581 3.581 0 1 1 1.151-6.974l1.011-.988a4.884 4.884 0 1 0 2.206 2.194m-1.696-1.902-.968.938a3.6 3.6 0 0 1 1.436 1.428l.958-.936a4.9 4.9 0 0 0-1.426-1.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.61 7.605-.983.972a10.1 10.1 0 0 1 .859 4.08c0 5.573-4.518 10.091-10.092 10.091S1.302 18.23 1.302 12.657c0-5.574 4.518-10.092 10.092-10.092 1.456 0 2.84.308 4.089.863l.986-.975a11.34 11.34 0 0 0-5.075-1.19C5.101 1.263 0 6.363 0 12.657 0 18.949 5.101 24.05 11.394 24.05v.001c6.293 0 11.394-5.102 11.394-11.394 0-1.814-.424-3.529-1.178-5.052m-4.541-4.831-.965.955a10.15 10.15 0 0 1 4.223 4.228l.963-.952a11.45 11.45 0 0 0-4.221-4.231"
  }))));
};
export default SvgEngagement;